import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 12px 16px 16px;
    @media (min-width: 800px) {
      padding: 16px 24px 16px;
    }
    border-top: 3px solid ${colors.silver};
  `,
  disabled: css`
    opacity: 70%;
  `,
  card: css`
    min-width: auto;
    height: 26px;
    margin: 5px;
    padding: 4px 8px 4px 8px;
    gap: 2px;
    display: flex;
    align-items: center;
    border: 1px solid ${colors.prussian};
    border-radius: 10px;
    cursor: pointer;
  `,
  free: css`
    background-color: ${colors.prussian300};
    border: none !important;
    svg {
      color: ${colors.prussian};
    }
  `,
  text: css`
    font-size: 12px;
    line-height: 12px;
    font-weight: 600;
    letter-spacing: 0.4px;
    color: ${colors.prussian};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  logo: css`
    height: 32px;
    width: 32px;
    margin-right: 3px;
  `,
};

export default styles;
